import React, { createContext, useContext, useState, useEffect } from "react";
import { toast } from "sonner";

const StoreContext = createContext(null);

export const StoreProvider = ({ children }) => {
  const [wishlist, setWishlist] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("aa_wishlist") || "[]");
    } catch {
      return [];
    }
  });
  const [cart, setCart] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("aa_cart") || "[]");
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem("aa_wishlist", JSON.stringify(wishlist));
  }, [wishlist]);

  useEffect(() => {
    localStorage.setItem("aa_cart", JSON.stringify(cart));
  }, [cart]);

  const toggleWishlist = (id) => {
    setWishlist((prev) => {
      if (prev.includes(id)) {
        toast("Removed from wishlist");
        return prev.filter((x) => x !== id);
      }
      toast.success("Added to wishlist");
      return [...prev, id];
    });
  };

  const addToCart = (product) => {
    setCart((prev) => [...prev, product.id]);
    toast.success(`${product.name} added to cart`);
  };

  return (
    <StoreContext.Provider value={{ wishlist, cart, toggleWishlist, addToCart }}>
      {children}
    </StoreContext.Provider>
  );
};

export const useStore = () => useContext(StoreContext);
